import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { SelectModule } from 'primeng/select';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { StickyLink, ICONS } from '../../../../../shared/public-api';

@Component({
  selector: 'create-sticky-link',
  imports: [FormsModule, InputTextModule, SelectModule, CommonModule, ButtonModule],
  templateUrl: './create-sticky-link.component.html',
  styleUrl: './create-sticky-link.component.scss',
})
export class CreateStickyLinkComponent implements OnInit {
  stickyLink = new StickyLink();
  ICONS = ICONS;

  constructor(
    private dialogRef: DynamicDialogRef,
    private dialogConfig: DynamicDialogConfig<{ link: StickyLink }>
  ) {}

  ngOnInit(): void {
    if (this.dialogConfig.data?.link) {
      this.stickyLink = this.dialogConfig.data.link;
    }
  }

  save(): void {
    this.dialogRef.close(this.stickyLink);
  }

  cancel(): void {
    this.dialogRef.close();
  }
}
